// mutations
const PAPELERIA_REQUESTS_ALL = (state, papeleriaRequests) => {
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests = papeleriaRequests.data
    state.status = 'success'
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_FORM = (state, papeleriaRequests) => {
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests = papeleriaRequests.data
    state.status = 'success'
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_SHOW = (state, papeleriaRequests) => {
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests = papeleriaRequests.data
    state.status = 'success'
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_CREATE = (state, papeleriaRequests) => {
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests = papeleriaRequests.data
    state.status = 'success'
    alert(papeleriaRequests.message)
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_UPDATE = (state, papeleriaRequests) => {
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests = papeleriaRequests.data
    state.status = 'success'
    alert(papeleriaRequests.message)
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_DELETE = (state, papeleriaRequests) => {
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests = papeleriaRequests.data
    state.status = 'success'
    alert(papeleriaRequests.message)
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_VALIDATE = (state, papeleriaRequests) => {
  let json = JSON.stringify(papeleriaRequests.data)
  localStorage.setItem('requestValidate', json)
  if (papeleriaRequests.code === 1) {
    state.papeleriaRequests.credential = papeleriaRequests.data
    state.status = 'success'
  } else {
    alert(papeleriaRequests.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_REQUESTS_ALL,
  PAPELERIA_REQUESTS_FORM,
  PAPELERIA_REQUESTS_SHOW,
  PAPELERIA_REQUESTS_CREATE,
  PAPELERIA_REQUESTS_UPDATE,
  PAPELERIA_REQUESTS_DELETE,
  PAPELERIA_REQUESTS_VALIDATE
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/requests/mutations.js